<template>
  <div>
    <!-- TODO 样式 -->
    <el-form label-position="left" label-width="110px" ref="form" size="small" v-model="form">
      <div class="container">
        <el-switch v-model="enable" active-text="开启分销" />
        <br />
        <br />
        <br />
        <el-form-item label="佣金比例">
          <el-row tyle="margin-bottom: 5px;">
            <el-col span="3">
              <el-input v-model="store.brokeragerate">
                <template slot="append"
                  >%</template
                >
              </el-input>
            </el-col>
          </el-row>

          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            分销佣金=(订单支付金额-配送费)*佣金比例
          </div>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            会员下单将不视为分销订单, 既不会产生分销佣金
          </div>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            分账订单会在订单确认收货7日后进行分账结算. 如果订单发生退货退款将认为无效不进行分账.
          </div>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            微信允许的分账最大期限是订单支付后30天内, 请及时发货, 以免造成分账失败.
          </div>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            请避免以上分账失败情况发生, 以保持您小程序品牌的良好信誉.
          </div>
        </el-form-item>
        <div class="button-wrap"></div>
        <div class="save-btn-container">
          <el-button type="primary" @click="updateStore">
            保存
          </el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc } from '../../service/index';
import { M } from '../../service/grpc';
import { getToken } from '../../service/helper';
import province from '../../assets/province';
import ssx from '../../assets/ssx';
import { getCachedStore } from '../../router/auth';

export default {
  data() {
    return {
      token: '',
      store: {},
      enable: false
    };
  },
  async created() {
    this.token = getToken();
    const res = await rpc('StoreAuthService.GetStore', M('Token', { token: this.token }));
    this.store = res;
    this.enable = res.enableprofitsharing === 2 ? true : false;
  },
  methods: {
    updateStore() {
      this.store.enableprofitsharing = this.enable ? 2 : 1;
      this.store.brokeragerate = parseInt(this.store.brokeragerate);
      if (this.store.enableprofitsharing === 2 && this.store.brokeragerate <= 0) {
        this.$message({
          message: '分账比例需为整数且大于0',
          type: 'error'
        });
        return;
      }
      rpc(
        'StoreStoreService.UpdateProfitSharing',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...this.store,
            businesshoursList: this.store.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: this.store.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      });
    }
  }
};
</script>

<style scoped>
.c {
  text-align: center;
  cursor: pointer;
}
.button-wrap {
  margin: 0;
}

.pro-tag {
  padding: 3px 5px;
  border-radius: 3px;
  background-color: #f5efe8;
  color: #c09c4a;
  font-size: 10px;
  margin-left: 10px;
}
.pro-text {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 5px;
}

.pro-triangle {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 2px;
}
</style>
